import { __read } from "tslib";
import { useRef } from 'react';
import { px, useResizeObserver } from '../../../foundation';
import { getRoundOffset, roundBadgeMarginKey } from './BadgeUtils';
/**
 * modify round badge offset to correct position,
 * only trigger when host element height change
 * @param badgeRef badge
 */
export var useRoundBadgeOffset = function (badgeRef) {
    var currHeightRef = useRef(0);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useResizeObserver(badgeRef, function (_a) {
        var _b = __read(_a, 1), badgeObsEntry = _b[0];
        var height = badgeObsEntry.contentRect.height;
        var element = badgeObsEntry.target;
        if (currHeightRef.current === height)
            return;
        currHeightRef.current = height;
        var offset = getRoundOffset(height / 2);
        element.style.setProperty(roundBadgeMarginKey, px(offset));
    }, { mode: 'throttle' });
};
